import { getClientToken, refreshClientToken } from "../auth";
import { type SseMessage, SseParser } from "./parse-sse";

/**
 * Open an authenticated SSE stream (native EventSource can't send a Bearer
 * header). Resolves when the server closes or the signal aborts; rejects on a
 * non-2xx response.
 */
export async function streamSse(
	url: string,
	onMessage: (m: SseMessage) => void,
	signal: AbortSignal,
): Promise<void> {
	const open = (token: string | null) =>
		fetch(url, {
			headers: {
				Accept: "text/event-stream",
				...(token && { Authorization: `Bearer ${token}` }),
			},
			signal,
		});
	let res = await open(getClientToken());
	if (res.status === 401) {
		res = await open(await refreshClientToken());
	}
	if (!(res.ok && res.body)) {
		throw new Error(`SSE ${url} failed: ${res.status}`);
	}
	const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
	const parser = new SseParser();
	for (;;) {
		const { value, done } = await reader.read();
		if (done) return;
		for (const m of parser.push(value)) onMessage(m);
	}
}
